export enum IsRequired {
  Yes = "Y",
  No = "N",
}

export enum ResponseStatusCode {
  UNAUTHORIZED = 401,
}
